import styled from 'styled-components'

export const CurrentBalance = styled.div`
  margin: 0 0 16px;
  font-size: 3em;
  font-weight: 700;
`
